import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
// import errorLog from './modules/errorLog'
// import permission from './modules/permission'
// import tagsView from './modules/tagsView'
// import user from './modules/user'
import questionHistory from './modules/questionHistory'
import navCollapse from "@/store/navCollapse";
import userMenuData from "@/store/userMenuData";
import userInfo from "@/store/userInfo";
import brand from "@/store/brand";
// import common from './modules/common'
// import getters from './getters'
Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        // errorLog,
        // permission,
        // tagsView,
        // common,
        questionHistory,
        userInfo,
        brand,
        navCollapse,
        userMenuData
    },
    // getters
})

export default store
